import {Injectable} from '@angular/core';
import {SearchDetailsNotificationService} from "@tva/ng-migration/student/services/search-details-notification.service";
import {CreSummaryService} from "@tva/ng-migration/student/services/cre-summary.service";
import {Student} from "@tva/ng-migration/student/models/student.model";

@Injectable({
  providedIn: 'root'
})
export class StudentCreTrackingService {
    pathwayEntries: [];
    afterSearch: (any, string, number, Array, object, date) => void;
    student: Student;

    constructor(private searchNotification: SearchDetailsNotificationService,
                private creSummary: CreSummaryService){
    }

    loadData(): void {
        this.creSummary.getCreSummary(this.student.schoolId, this.student.studentId).subscribe((response) => {
            const selectedPathwayEntries = [];
            const pathwaySummary = [];
            const pathwayCompleted = [];

            const pathwayRequirements = response.selectedPathway.pathwayRequirements || [];
            const pathwayName = response.selectedPathway.name;
            const pathwayStatus = response.selectedPathway.completionStatusId;
            const pathwaySummaryData = response.pathwaysSummary;
            const pathwayCompletedData = response.completedPathways;

            pathwayRequirements.forEach(requirement => selectedPathwayEntries.push(...requirement.requiredCourses));
            pathwaySummaryData.forEach(pathway => pathwaySummary.push(pathway));
            pathwayCompletedData.forEach(pathway => pathwayCompleted.push(pathway));
            this.afterSearch(pathwayRequirements,pathwayName,pathwayStatus,selectedPathwayEntries, pathwaySummary, pathwayCompleted);
        });
    }

    registerStudentSearchUpdate(): void {
        this.searchNotification.studentObservable.subscribe((student)=>{
            this.student = student;
            this.loadData();
        })
    }

    registerAfterSearch(afterSearch): void {
        this.afterSearch = afterSearch;
    }
}
